import { FunctionComponent } from "react";

import { Option, OptionsSelect, OptionsSelectProps } from "@bps/fluent-ui";
import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { useApplicationsRefData } from "@libs/api/gateways/plt/plt-gateway.hooks";
import { RefDataDto } from "@libs/api/types/common-dtos";
import { config } from "@libs/config/config";

export interface ApplicationsSelectProps
  extends Omit<OptionsSelectProps, "options"> {
  excludeCam?: boolean;
}

export const ApplicationsSelect: FunctionComponent<ApplicationsSelectProps> = props => {
  const { isLoading, error, data } = useApplicationsRefData();
  const applications = data ?? [];

  const options: Option<RefDataDto>[] = applications.map(data => ({
    key: data?.code,
    text: data?.text,
    data
  }));

  const filteredOptions = props.excludeCam
    ? options.filter(o => o.key !== ApplicationType.CAM)
    : options;

  // PBI#48291 - We are disabling support for any user to create PrOS tenants in production
  // this is done because Fieldman will create the PrOS tenants going forward
  const prodFilteredOptions = filteredOptions.filter(o =>
    config.env === "prod" ? o.key !== ApplicationType.PROS : true
  );

  return (
    <OptionsSelect
      options={prodFilteredOptions}
      errorMessage={error?.message}
      loading={isLoading}
      hideSearchOption
      {...props}
    />
  );
};
